import { Placeholder } from '@wordpress/components';
import classNames from 'classnames';
import './styles.scss';

const CampaignImage = ({
    isEdit,
    mediaPlaceholder,
    image
}) => {
    return (
        <div className="campaign__col campaign__col--image">
            <div className="campaign__image-container">
                <figure className="campaign__image">
                    {isEdit && 
                        <>
                            {image && <img src={ image.src } alt={ image.alt } />}
                            {mediaPlaceholder}
                        </>
                    }
                    {!isEdit &&
                        <img src={ image.src } alt={ image.alt } />
                    }
                </figure>
            </div>
        </div>
    );
};

const Campaign = ({
    children,
    image,
    mediaPlaceholder = null,
    isEdit = false,
    isImageLeft,
    hideImage
}) => {
    return (
        <div className={classNames({
            'campaign': true, 
            'campaign--is-image-left': isImageLeft,
            'campaign--has-image': image || !hideImage,
            'campaign--hide-image': hideImage,
            'campaign--is-edit': isEdit
        })}>
            <div className="campaign__columns">
                <div className="campaign__col">
                    <div className="campaign__content">
                        {children}
                    </div>
                </div>
                {isEdit && !hideImage &&
                    <CampaignImage isEdit={isEdit} image={image} mediaPlaceholder={mediaPlaceholder} />
                }

                {!isEdit && image && !hideImage &&
                    <CampaignImage image={image} />
                }


            </div>
        </div>
    );
};

export default Campaign;